import { Injectable } from '@angular/core';
import {AuthService} from './auth.service';
import {StoreService} from './store.service';
import {FormService} from "./form.service";
import {ModeratorService} from './moderator.service';

@Injectable({
  providedIn: 'root'
})
export class GuardService {

  auth: any;

  constructor(private _authService: AuthService,
              private _storeService: StoreService,
              private _moderatorService: ModeratorService,
              private formService: FormService) {
  }

  isAuth() {
    return new Promise((resolve, reject) => {
      this.auth = this._storeService.auth;

      if (this.auth === null)
        this._authService.isAuth().subscribe(
          res => {
            if (!res) {
              this.auth = res;
              return resolve(res);
            }
            this._moderatorService.getConfig({}).subscribe(
              (res: any) => {
              },
              err => {
                console.log(err);
              },
              () => {
                this.auth = res;
                resolve(res);
              }
            );
          },
          err => resolve(false)
        );
      else
        resolve(false);
    });
  }

  skipChanges() {
    return new Promise((resolve, reject) => {
      if (this.formService.getForceSkipCheck()) return resolve(true);

      let result = this.formService.activeForms.some(form => {
        return this.formService.checkChanges(form);
      });

      if (result) {
        result = !confirm('You didn\'t save changes. Would you discard?');

        // if (result) {
        //   this.formService.setActiveFo rms([]);
        // }
      }

      resolve(!result);
    })
  }
}
